// extracted by mini-css-extract-plugin
export default {"productGrid":"PZ-z","centerLink":"QZ-z","productSection":"RZ-z","item":"SZ-z","ctaButton":"TZ-z"};